package com.nonopn.skywatcher.common.app.api

enum class Mode {
    Normal,
    Admin
}